import RecruiterDashboard from "./components/RecruiterDashboard";

function App() {
  return <RecruiterDashboard />;
}

export default App;
